import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@modusign/design-system';

export default function LightHelpButton() {
  return (
    <Tooltip content="도움말" mode="day" placement="bottom" scale="sm">
      <Box
        aria-label="도움말"
        as="button"
        className="tagHelpButton"
        color="textNeutralLightest"
        p={1}
      >
        <Box fontSize="18px" fontWeight="regular">
          <FontAwesomeIcon icon={faQuestionCircle as IconProp} />
        </Box>
      </Box>
    </Tooltip>
  );
}
